import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import InputTextJSX from './InputTextJSX';
import { adminMainUrl } from '../../../../Config';
import axios from 'axios';
import { toast } from 'react-toastify';
import Select from "react-select";
import { customStyles } from '../../../../HelperFunctions';
import { useDispatch, useSelector } from 'react-redux';
import { getStateListByCountry } from '../../../../Redux/action/MasterAction';
import Beatloader from '../../../../Common/Loaders/Beatloader';

const EditCity = ({ city_id, show, handleClose, token, user_id, refresh, loadingCountry, destinationCountryData, loadingMasterCityDetail, MasterCityDetail }) => {
    const dispatch = useDispatch();
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [countryOptions, setCountryOptions] = useState([]);
    let initialValues = {
        name: "",
        country_id: "",
        state_id: "",
        // latitude: "",
        // longitude: "",
    };

    useEffect(() => {
        if (destinationCountryData) {
            let arr = [];
            destinationCountryData.map(val => { arr.push({ value: val.id, label: val.name }) });
            setCountryOptions(arr);
        }
    }, [destinationCountryData]);







    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            try {
                let config = {
                    headers: {
                        'auth-token': token,
                        'user_id': user_id
                    }
                }
                if (city_id) {
                    values.id = city_id
                } else {
                    toast.error("ID is required.");
                    return;
                }
                setDisableSubmit(true);
                axios.post(`${adminMainUrl}/api/master/city/edit`, values, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            refresh();
                            // resetForm();
                            handleClose();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });

    useEffect(() => {
        if (token && user_id && formik.values.country_id) {
            dispatch(getStateListByCountry(token, user_id, formik.values.country_id,))
        }
    }, [formik.values.country_id]);


    const [showLoader, setShowLoader] = useState(false);

    useEffect(() => {
        if (loadingMasterCityDetail) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (MasterCityDetail) {
            formik.setFieldValue("name", MasterCityDetail?.name);
            formik.setFieldValue("country_id", MasterCityDetail?.country_id);
            formik.setFieldValue("state_id", MasterCityDetail?.state_id);
        }
    }, [loadingMasterCityDetail, MasterCityDetail]);

    const [stateOptions, setStateOptions] = useState([]);

    const {
        loadingMasterStateByCountryList,
        MasterStateByCountryList,
        MasterStateByCountryListError
    } = useSelector(state => state.MasterReducer);


    useEffect(() => {
        if (MasterStateByCountryList) {
            // console.log(MasterStateByCountryList);

            let arr = [];
            MasterStateByCountryList.map(val => { arr.push({ value: val.id, label: val.name }) });
            setStateOptions(arr);
        }
    }, [loadingMasterStateByCountryList, MasterStateByCountryList])

    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title>Edit City</Offcanvas.Title>
                        </Offcanvas.Header>
                        <Offcanvas.Body>
                            <form onSubmit={formik.handleSubmit}>
                                <div className="row">
                                    <InputTextJSX
                                        labelText={"City Name"}
                                        nameValue={"name"}
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                    />


                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                Country
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={countryOptions}
                                                    styles={customStyles}
                                                    name="country_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('country_id', option.value);
                                                        // handleGetStates(option.value);
                                                    }}
                                                    value={countryOptions.find(option => option.value == formik.values.country_id) || null}
                                                    isLoading={loadingCountry}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className={`col-md-6 mt-2`}>
                                        <div className='ms-2'>
                                            <label htmlFor="" className='form-label  mb-0'>
                                                State
                                            </label>
                                            <div className="icon-forms mb-3 mb-sm-0">
                                                <Select
                                                    className='custom-selector'
                                                    options={stateOptions}
                                                    styles={customStyles}
                                                    name="state_id"
                                                    onChange={option => {
                                                        formik.setFieldValue('state_id', option.value);
                                                    }}
                                                    value={stateOptions.find(option => option.value == formik.values.state_id) || null}
                                                    isLoading={loadingCountry}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row d-flex justify-content-end mt-2">
                                        <div className="col-md-6 d-flex justify-content-end">
                                            <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                                {
                                                    disableSubmit ?
                                                        <>
                                                            <i className="fas fa-spinner fa-spin"></i> Saving...
                                                        </>
                                                        :
                                                        "Update"
                                                }
                                            </button>
                                        </div>
                                    </div>


                                </div>
                            </form>
                        </Offcanvas.Body>
                    </Offcanvas>
            }
        </>
    )
}

export default EditCity